import { render, staticRenderFns } from "./ServiceOrdersTable.vue?vue&type=template&id=04fa658a&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ServiceOrdersTable.vue?vue&type=style&index=0&id=04fa658a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fa658a",
  null
  
)

export default component.exports